const COMMON_CLASS_NAMES = Object.freeze({
  mainContentContainerWidth: 'mx-auto sm:max-w-3xl w-full lg:max-w-7xl',
  mainContentContainerHorizontalPadding: 'px-6 sm:px-6 lg:px-8',
  scaleOnHover: 'transform transition duration-500 hover:scale-110',
  input:
    'min-h-[1.25rem] bg-white border-0 p-0 text-black outline-none ring-0 transition-colors duration-300 placeholder:font-dm-sans placeholder:text-grey400 focus:outline-none focus:ring-0 shadow-none resize-none',
  inputContainer:
    'flex min-h-[3.5rem] bg-white h-auto w-full flex-col rounded-xl border border-grey400 px-6 py-2',
  inputError: 'bg-error-light border-error focus:border-error',
});

export default COMMON_CLASS_NAMES;
